import { useNewCode } from '@calendly/feature-check-react'
import { useSelector } from 'react-redux'

import { useGetUserQuery } from 'common'
import {
  currentTierSelector,
  isCurrentSubscriptionInitializedSelector,
  isEnterpriseSelector
} from 'features/billing'
import { isEnglishLocale, NOTETAKER_VISIBILITY_GATING_FLAG } from 'shared/constants/notetaker_visibility'

import { useNotetakerMsaOrg } from './useNotetakerMsaOrg'

/**
 * Single choke point for locale/tier/MSA market eligibility and the visibility Statsig gate.
 * When gating is off, every user is market-eligible so render and experiment enrollment stay in sync.
 */
export const useNotetakerMarketEligibility = () => {
  const isGatingEnabled = useNewCode(NOTETAKER_VISIBILITY_GATING_FLAG)?.enabled
  const { data: userData, isLoading: isUserLoading } = useGetUserQuery()
  const isEnterprise = useSelector(isEnterpriseSelector)
  const isSubscriptionInitialized = useSelector(isCurrentSubscriptionInitializedSelector)
  const currentTier = useSelector(currentTierSelector)
  const isMsaOrg = useNotetakerMsaOrg()

  if (isGatingEnabled === undefined) {
    return { isEligible: false, isLoading: true }
  }

  if (!isGatingEnabled) {
    return { isEligible: true, isLoading: false, isGatingEnabled: false }
  }

  const isLoading = isUserLoading || !isSubscriptionInitialized
  const isEnglish = isEnglishLocale(userData?.locale)
  // A settled subscription always carries a tier (`basic` when free, `teams` on trial), so a missing
  // one means the fetch failed. `isEnterprise` would read false there and admit an Enterprise user.
  const isTierResolved = currentTier != null
  const isEligible = !isLoading && isTierResolved && isEnglish && !isEnterprise && !isMsaOrg

  return { isEligible, isLoading, isGatingEnabled: true }
}
